import { render, staticRenderFns } from "./ActivitiesTotalSpend.vue?vue&type=template&id=2ad1f376&scoped=true&"
import script from "./ActivitiesTotalSpend.vue?vue&type=script&lang=ts&"
export * from "./ActivitiesTotalSpend.vue?vue&type=script&lang=ts&"
import style0 from "./ActivitiesTotalSpend.vue?vue&type=style&index=0&id=2ad1f376&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad1f376",
  null
  
)

export default component.exports